(function () {
  'use strict';

  var root = document.getElementById('review-page-root');
  if (!root) return;

  var API = root.dataset.api;
  var i18n = {
    invalid: root.dataset.i18nInvalid,
    expired: root.dataset.i18nExpired,
    used: root.dataset.i18nUsed,
    heading: root.dataset.i18nHeading,
    rating: root.dataset.i18nRating,
    titleLabel: root.dataset.i18nTitleLabel,
    bodyLabel: root.dataset.i18nBodyLabel,
    bodyPlaceholder: root.dataset.i18nBodyPlaceholder,
    submit: root.dataset.i18nSubmit,
    successHeading: root.dataset.i18nSuccessHeading,
    successBody: root.dataset.i18nSuccessBody,
    error: root.dataset.i18nError,
    photoLabel: root.dataset.i18nPhotoLabel,
    photoHint: root.dataset.i18nPhotoHint,
  };

  var token = new URLSearchParams(window.location.search).get('token');

  function showError(msg) {
    root.innerHTML =
      '<div style="text-align:center;padding:60px 20px">' +
      '<p style="font-size:18px;color:#666">' + esc(msg) + '</p>' +
      '</div>';
  }

  function showSuccess() {
    root.innerHTML =
      '<div style="text-align:center;padding:60px 20px">' +
      '<h2 style="font-size:28px;font-weight:700;margin:0 0 12px">' + esc(i18n.successHeading) + '</h2>' +
      '<p style="font-size:16px;color:#555">' + esc(i18n.successBody) + '</p>' +
      '</div>';
  }

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function renderForm(product) {
    root.innerHTML =
      '<div style="text-align:center;margin-bottom:28px">' +
        (product.productImage ? '<img src="' + esc(product.productImage) + '" alt="' + esc(product.productTitle) + '" style="max-width:180px;max-height:180px;object-fit:contain;margin:0 auto 16px;display:block">' : '') +
        '<h1 style="font-size:24px;font-weight:700;margin:0 0 6px">' + esc(i18n.heading) + '</h1>' +
        '<p style="font-size:16px;color:#444;margin:0">' + esc(product.productTitle) + '</p>' +
      '</div>' +
      '<form id="review-form">' +
        '<div style="margin-bottom:20px">' +
          '<label style="display:block;font-size:14px;font-weight:600;margin-bottom:8px">' + esc(i18n.rating) + '</label>' +
          '<div class="rev-stars" id="star-picker" style="display:flex;gap:8px;font-size:36px;cursor:pointer">' +
            '<span data-v="1">&#9733;</span>' +
            '<span data-v="2">&#9733;</span>' +
            '<span data-v="3">&#9733;</span>' +
            '<span data-v="4">&#9733;</span>' +
            '<span data-v="5">&#9733;</span>' +
          '</div>' +
          '<input type="hidden" id="rev-rating" name="rating" value="">' +
        '</div>' +
        '<div style="margin-bottom:16px">' +
          '<label for="rev-title" style="display:block;font-size:14px;font-weight:600;margin-bottom:6px">' + esc(i18n.titleLabel) + '</label>' +
          '<input type="text" id="rev-title" maxlength="200" style="width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:4px;font-size:15px;box-sizing:border-box">' +
        '</div>' +
        '<div style="margin-bottom:24px">' +
          '<label for="rev-body" style="display:block;font-size:14px;font-weight:600;margin-bottom:6px">' + esc(i18n.bodyLabel) + ' *</label>' +
          '<textarea id="rev-body" maxlength="2000" rows="5" placeholder="' + esc(i18n.bodyPlaceholder) + '" style="width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:4px;font-size:15px;box-sizing:border-box;resize:vertical"></textarea>' +
        '</div>' +
        '<div style="margin-bottom:24px">' +
          '<label style="display:block;font-size:14px;font-weight:600;margin-bottom:6px">' + esc(i18n.photoLabel) + '</label>' +
          '<p style="font-size:12px;color:#888;margin:0 0 8px">' + esc(i18n.photoHint) + '</p>' +
          '<label for="rev-photos" style="display:inline-flex;align-items:center;gap:6px;cursor:pointer;background:#f5f5f5;border:1px dashed #ccc;border-radius:4px;padding:8px 14px;font-size:14px;color:#555">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' +
            'Pasirinkti nuotraukas' +
          '</label>' +
          '<input type="file" id="rev-photos" accept="image/jpeg,image/png,image/webp" multiple style="display:none">' +
          '<div id="rev-photo-previews" style="display:flex;flex-wrap:wrap;gap:8px;margin-top:10px"></div>' +
        '</div>' +
        '<p id="rev-error" style="color:#c00;font-size:14px;margin:0 0 12px;display:none"></p>' +
        '<button type="submit" id="rev-submit" style="display:block;width:100%;background:#111;color:#fff;font-size:16px;font-weight:600;padding:14px;border:none;border-radius:4px;cursor:pointer">' + esc(i18n.submit) + '</button>' +
      '</form>';

    initStarPicker();
    initPhotoInput();
    initForm();
  }

  function initStarPicker() {
    var stars = document.querySelectorAll('#star-picker span');
    var ratingInput = document.getElementById('rev-rating');

    function paint(val) {
      stars.forEach(function (s) {
        s.style.color = parseInt(s.dataset.v) <= val ? '#f5a623' : '#ccc';
      });
    }

    paint(0);

    stars.forEach(function (s) {
      s.addEventListener('mouseenter', function () { paint(parseInt(s.dataset.v)); });
      s.addEventListener('click', function () {
        ratingInput.value = s.dataset.v;
        paint(parseInt(s.dataset.v));
      });
    });

    document.getElementById('star-picker').addEventListener('mouseleave', function () {
      paint(parseInt(ratingInput.value) || 0);
    });
  }

  var selectedFiles = [];

  function initPhotoInput() {
    var input = document.getElementById('rev-photos');
    var previews = document.getElementById('rev-photo-previews');
    if (!input || !previews) return;

    input.addEventListener('change', function () {
      var newFiles = Array.from(input.files || []).filter(function (f) {
        return ['image/jpeg', 'image/png', 'image/webp'].includes(f.type) && f.size <= 5 * 1024 * 1024;
      });
      selectedFiles = selectedFiles.concat(newFiles).slice(0, 5);
      input.value = '';

      previews.innerHTML = '';
      selectedFiles.forEach(function (file, idx) {
        var url = URL.createObjectURL(file);
        var wrap = document.createElement('div');
        wrap.style.cssText = 'position:relative;width:72px;height:72px';
        wrap.innerHTML =
          '<img src="' + url + '" style="width:72px;height:72px;object-fit:cover;border-radius:4px;border:1px solid #ddd">' +
          '<button type="button" data-idx="' + idx + '" style="position:absolute;top:-6px;right:-6px;background:#333;color:#fff;border:none;border-radius:50%;width:18px;height:18px;font-size:12px;line-height:1;cursor:pointer;padding:0">&times;</button>';
        previews.appendChild(wrap);
      });

      previews.querySelectorAll('button[data-idx]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.dataset.idx);
          selectedFiles.splice(idx, 1);
          input.dispatchEvent(new Event('change'));
        });
      });
    });
  }

  function initForm() {
    document.getElementById('review-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var rating = parseInt(document.getElementById('rev-rating').value);
      var body = document.getElementById('rev-body').value.trim();
      var title = document.getElementById('rev-title').value.trim();
      var errEl = document.getElementById('rev-error');

      if (!rating || rating < 1 || rating > 5) {
        errEl.textContent = i18n.rating + ': ?';
        errEl.style.display = 'block';
        return;
      }
      if (!body) {
        errEl.textContent = i18n.bodyLabel + '?';
        errEl.style.display = 'block';
        return;
      }
      errEl.style.display = 'none';

      var btn = document.getElementById('rev-submit');
      btn.disabled = true;
      btn.style.opacity = '0.6';

      function doSubmit(imageUrls) {
        fetch(API + '/reviews/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token, rating: rating, title: title, body: body, images: imageUrls }),
        })
          .then(function (res) { return res.json().then(function (d) { return { status: res.status, data: d }; }); })
          .then(function (r) {
            if (r.data.ok === true) {
              showSuccess();
            } else if (r.data.error === 'already_reviewed') {
              showError(i18n.used);
            } else if (r.data.error === 'link_expired') {
              showError(i18n.expired);
            } else if (r.data.error === 'invalid_token') {
              showError(i18n.invalid);
            } else {
              errEl.textContent = i18n.error;
              errEl.style.display = 'block';
              btn.disabled = false;
              btn.style.opacity = '1';
            }
          })
          .catch(function () {
            errEl.textContent = i18n.error;
            errEl.style.display = 'block';
            btn.disabled = false;
            btn.style.opacity = '1';
          });
      }

      if (selectedFiles.length > 0) {
        var formData = new FormData();
        formData.append('token', token);
        selectedFiles.forEach(function (f, i) { formData.append('images', f); });
        fetch(API + '/reviews/upload-images', { method: 'POST', body: formData })
          .then(function (res) { return res.json(); })
          .then(function (d) { doSubmit(d.urls || []); })
          .catch(function () { doSubmit([]); });
      } else {
        doSubmit([]);
      }
    });
  }

  if (!token) {
    showError(i18n.invalid);
    return;
  }

  fetch(API + '/reviews/token/' + encodeURIComponent(token))
    .then(function (res) {
      if (res.status === 410) return res.json().then(function (d) { return { status: 410, data: d }; });
      if (!res.ok) return { status: res.status, data: {} };
      return res.json().then(function (d) { return { status: 200, data: d }; });
    })
    .then(function (r) {
      if (r.status === 410) {
        var reason = r.data.reason;
        if (reason === 'already_used') showError(i18n.used);
        else if (reason === 'expired') showError(i18n.expired);
        else showError(i18n.invalid);
      } else if (r.status === 200 && r.data.ok) {
        renderForm(r.data);
      } else {
        showError(i18n.invalid);
      }
    })
    .catch(function () { showError(i18n.invalid); });
})();
